module.exports = __webpack_public_path__ + "media/images/flags/4x3/aut-014b94b117f983cda8ff1df277bb13a5.svg";